<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const phone = $derived(String(value ?? ''))
  const displayValue = $derived(formatPhone(phone))

  function formatPhone(input: string): string {
    const digits = input.replace(/\D/g, '')

    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    }

    if (digits.length === 11 && digits.startsWith('1')) {
      return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
    }

    return input
  }
</script>

<a class="widget-phone" href={`tel:${phone}`}>{displayValue}</a>
